<div [hidden]="consulta">
    <div class="row">
        <div class="col-lg-12" style="padding: 0px;">
            <section class="widget">
                <!-- título -->
                <header>
                    <h3> {{sistemaService.NombrePantallaActual}}: {{accion.accion}}</h3>
                </header>
                <div class="separador"></div>
                    <div *ngIf="ver == false">
                        <filtros (filtroAplicado)="SetDatos($event)" [filtros]="filtrosDisplay" [urlApi]="uriApi" [verBotonConsultar]="false" [verpanel]="filtrosDisplay[filtroindextipo].Valor && parametro" #filtrosComponent></filtros>
                    </div>
            </section>

            <div class="divisor8"></div>

            <section class="widget">
                <div class="divisor8"></div>
                <div class="row">
                    <div class="col-lg-3 col-md-3 col-sm-6 col-12">
                        <inputCustom [titulo]="'Descripción de la plantilla*'" [disabled]="ver" [(ngModel)]="entidad.descripcion" [errorActivo]="errorActivo" ></inputCustom>
                    </div>
                    <div class="col-lg-3 col-md-3 col-sm-6 col-12">
                        <dropdownCustom [titulo]="'Tipo de plantilla*'"
                           [opciones]="SelTipoplantilla" [disabled]="ver"
                           [(ngModel)]="entidad.tipoplantillaid"
                           [valorName]="'tipoplantillaid'"
                           [displayValor]="'nombre'"
                           [buscar]="false"
                           [errorActivo]="errorActivo"
                           (ngModelChange)="cargarinfo($event)"
                           ></dropdownCustom>
                   </div>
                   <div *ngIf="verevaluador" class="col-lg-3 col-md-3 col-sm-6 col-12">
                        <dropdownCustom [titulo]="'Evaluador*'"
                        [opciones]="viewEvaluador" [disabled]="ver"
                        [(ngModel)]="entidad.evaluadorid"
                        [valorName]="'evaluadorid'"
                        [displayValor]="'nombre'"
                        [buscar]="false"
                        [errorActivo]="errorActivo"
                        (ngModelChange)="selectevaluador($event, 1)"
                        ></dropdownCustom>
                    </div>
                    <div *ngIf="vernivel" class="col-lg-3 col-md-3 col-sm-6 col-12">
                        <dropdownCustom [titulo]="nombrenivel"
                        [opciones]="SelNivellista" [disabled]="ver"
                        [(ngModel)]="entidad.nivelid"
                        [multiSelect]="true"
                        [valorName]="'nivelid'"
                        [displayValor]="'nombre'"
                        [buscar]="false"
                        [errorActivo]="errornivel"
                        [verError]="errornivel"
                        (ngModelChange)="filtrargrado($event)"
                        ></dropdownCustom>
                    </div>
                </div>
                <div class="row">
                    <div *ngIf="verdepartamento" class="col-lg-3 col-md-3 col-sm-6 col-12">
                        <multiSelect [titulo]="'Departamento(s)*'"
                            [opciones]="SelDepartamentolista" [disabled]="ver"
                            [(ngModel)]="entidad.departamentoid"
                            [valorName]="'departamentoid'"
                            [displayValor]="'nombre'"
                            [buscar]="true"
                            [errorActivo]="errorActivo"
                            (ngModelChange)="filtrarpuesto($event)"
                            ></multiSelect>
                    </div>
                    <div *ngIf="verpuesto" class="col-lg-3 col-md-3 col-sm-6 col-12">
                        <multiSelect [titulo]="'Puesto(s)*'" #selectpuesto
                        [opciones]="SelPuestoslista" [disabled]="ver"
                        [(ngModel)]="entidad.puestoid"
                        [valorName]="'puestoid'"
                        [displayValor]="'nombre'"
                        [errorActivo]="errorActivo"
                        [buscar]="true"
                        ></multiSelect>
                    </div>
                    <div *ngIf="vergrado" class="col-lg-3 col-md-3 col-sm-6 col-12">
                        <multiSelect [titulo]="'Grado(s)*'" #selectgrado
                        [opciones]="SelGradoslista" [disabled]="ver"
                        [(ngModel)]="entidad.gradoid"
                        [valorName]="'gradoid'"
                        [displayValor]="'nombre'"
                        [buscar]="false"
                        [errorActivo]="errorActivo"
                        (ngModelChange)="limpiarmaterias($event)"
                        ></multiSelect>
                    </div>
                    <div *ngIf="vermateria" class="col-lg-3 col-md-3 col-sm-6 col-12" style="text-align: right;">
                        <button [disabled]="ver" class="boton botonSM filled" (click)="SetMateria()">
                            <span> {{'Mostrar materias'}}</span>
                        </button>
                    </div>
                    <div *ngIf="vermateria" class="col-lg-3 col-md-3 col-sm-6 col-12">
                        <multiSelecttreeview [titulo]="'Materia(s)*'" #selectmateria
                        [opciones]="SelMateria" [disabled]="ver"
                        [(ngModel)]="entidad.materiaid"
                        [listaselect]="listamateriastring"
                        [valorName]="'materiaid'"
                        [displayValor]="'text'"
                        [displayValorView]="3"
                        [buscar]="false"
                        [errorActivo]="errorActivo"
                        ></multiSelecttreeview>

                    </div>
                    <div *ngIf="veractivo" class="col-lg-3 col-md-3 col-sm-6 col-12" style="display: table;">
                        <div style="display: table-cell;">
                            <checkBoxCustom [titulo]="'Activo'" [disabled]="ver" [alineacion]="1" [(ngModel)]="entidad.activo" ></checkBoxCustom>
                        </div>
                        <div>
                            <button class="boton botonSM filled" [disabled]="ver" (click)="Consultar()">
                                Consultar
                              </button>
                        </div>
                    </div>
                    <div *ngIf="veractivo" class="col-lg-3 col-md-3 col-sm-6 col-12">

                    </div>
                </div>

                <div class="row">
                    <div class="col-lg-5 col-md-12 col-sm-12 col-12">
                        <div >
                            <h5>Preguntas disponibles</h5>
                            <!-- datos -->
                                <div >
                            <dx-data-grid #grid
                                (onOptionChanged)="sistemaService.CambiarPaginacionTabla($event)"
                                id="tabla" [disabled]="ver"
                                [columnAutoWidth]="true"
                                [dataSource]="dataTablePreguntas"
                                [noDataText]="'Sin Datos'"
                                keyExpr="preguntaid"
                                [(selectedRowKeys)]="selectedRows"
                                [showColumnHeaders]="true">

                                <dxo-search-panel
                                    [visible]="true"
                                    [width]="240"
                                    placeholder="{{'Buscar' | translate}}">
                                </dxo-search-panel>

                                <dxo-paging
                                    [pageSize]="sistemaService.tablaPaginacion"></dxo-paging>
                                <!--<dxo-scrolling mode="virtual" [useNative]="false" [showScrollbar]="'always'"></dxo-scrolling>-->
                                <dxo-pager
                                    [visible]="true"
                                    [allowedPageSizes]="sistemaService.tablaPaginacionPaginaSize"
                                    [displayMode]="sistemaService.tablaPaginacionModo"
                                    [showPageSizeSelector]="sistemaService.tablaPaginacionSelector"
                                    [showInfo]="sistemaService.tablaPaginacionInfo"
                                    [showNavigationButtons]="sistemaService.tablaPaginacionNavegacion">
                                </dxo-pager>

                                <dxo-column-chooser
                                #columnChooser
                                [enabled]="true"
                                [mode]="'select'"
                              >
                                <dxo-position
                                  my="right top"
                                  at="right bottom"
                                  of=".dx-datagrid-column-chooser-button"
                                ></dxo-position>

                                <dxo-selection
                                selectByClick="true"
                              ></dxo-selection>
                              </dxo-column-chooser>
                                <dxo-column-fixing [enabled]="true"></dxo-column-fixing>
                                <dxo-selection mode="multiple" [showCheckBoxesMode]="'always'"></dxo-selection>
                                <!-- <dxi-column [allowFixing]="false"
                                dataField="clave"
                                caption="Clave"
                                alignment="left">
                                </dxi-column> -->
                                <dxi-column
                                    dataField="pregunta"
                                    caption="Pregunta">
                                </dxi-column>
                                <dxi-column
                                    dataField="nivel"
                                    caption="Nivel">
                                </dxi-column>
                                <dxi-column
                                dataField="tipopregunta"
                                caption="Tipopregunta"
                                [visible]="false">
                                </dxi-column>
                                <dxi-column
                                  dataField="escalaevaluacion"
                                    caption="Escala evaluación"
                                    [visible]="false">
                                </dxi-column>
                                <dxi-column
                                dataField="competencia"
                                caption="competencia"
                                [visible]="false">
                                </dxi-column>
                                <dxi-column
                                dataField="criterio"
                                caption="criterio"
                                [visible]="false">
                                </dxi-column>
                                <dxi-column
                                dataField="mostrarautoevaluacion"
                                caption="Autoevaluacion"
                                cellTemplate="cellAutoevaluacion"
                                [calculateCellValue]="filtroporboleando"
                                alignment="center">
                            </dxi-column>
                                                    <!-- Activo -->
                        <div *dxTemplate="let cell of 'cellAutoevaluacion'" class="iconoActivo">
                            <span *ngIf="cell.data.mostrarautoevaluacion" class="fa fa-check"></span>
                            <span *ngIf="!cell.data.mostrarautoevaluacion"  class="fa fa-times"></span>
                        </div>
                            </dx-data-grid>

                        </div>
                        </div>
                    </div>
                    <div class="col-lg-2 col-md-12 col-sm-12 col-12">
                        <div class="basebotones">
                            <div class="">
                                <div *ngIf="accion.accionid != 1" class="row margen ">
                                    <div class="col-12">
                                            <button
                                                class="boton botonXS tamañoboton" [disabled]="ver"
                                                (click)="AgregarPreguntasPlantillas()">
                                                <span> {{'Asignar '}} </span><span class="fa fa-arrow-right"></span>
                                            </button>
                                    </div>
                                </div>
                                <br>
                                <br>
                                <div *ngIf="accion.accionid != 1" class=" row margen">
                                    <div class="col-12">
                                            <button
                                                class="boton botonXS tamañoboton" [disabled]="ver"
                                                (click)="QuitarPreguntasPlantillas()">
                                                <span class="fa fa-arrow-left"></span><span> {{' Quitar'}}</span>
                                            </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-5 col-md-12 col-sm-12 col-12">
                        <div>
                            <div style="display: flex; justify-content: space-between; align-items: center;">
                                <h5 style="margin: 0;">Preguntas asignadas</h5>
                                <span><b>Total de preguntas asignadas: </b>{{dataTablePreguntaPlantilla.length}}</span>
                            </div>
                            <br>
                                <!-- datos -->
                                    <div >
                                <dx-data-grid #grid
                                    (onOptionChanged)="sistemaService.CambiarPaginacionTabla($event)"
                                    id="tabla"
                                    [columnAutoWidth]="true"
                                    [dataSource]="dataTablePreguntaPlantilla"
                                    keyExpr="preguntaid"
                                    [noDataText]="'Sin Datos'"
                                    [(selectedRowKeys)]="dataTablePreguntasSeleccionadas"
                                    [showColumnHeaders]="true">

                                <dxo-search-panel
                                [visible]="true"
                                [width]="240"
                                placeholder="{{'Buscar' | translate}}">
                            </dxo-search-panel>
                                    <dxo-paging
                                        [pageSize]="sistemaService.tablaPaginacion"></dxo-paging>
                                    <!--<dxo-scrolling mode="virtual" [useNative]="false" [showScrollbar]="'always'"></dxo-scrolling>-->
                                    <dxo-pager
                                        [visible]="true"
                                        [allowedPageSizes]="sistemaService.tablaPaginacionPaginaSize"
                                        [displayMode]="sistemaService.tablaPaginacionModo"
                                        [showPageSizeSelector]="sistemaService.tablaPaginacionSelector"
                                        [showInfo]="sistemaService.tablaPaginacionInfo"
                                        [showNavigationButtons]="sistemaService.tablaPaginacionNavegacion">
                                    </dxo-pager>


                                <dxo-column-chooser
                                #columnChooser
                                [enabled]="true"
                                [mode]="'select'"
                              >
                                <dxo-position
                                  my="right top"
                                  at="right bottom"
                                  of=".dx-datagrid-column-chooser-button"
                                ></dxo-position>

                                <dxo-selection
                                selectByClick="true"
                              ></dxo-selection>
                              </dxo-column-chooser>

                                    <dxo-column-fixing [enabled]="true"></dxo-column-fixing>
                                    <dxo-editing mode="cell" [allowUpdating]="true"></dxo-editing>
                                    <dxo-selection mode="multiple" [showCheckBoxesMode]="'always'" *ngIf="!ver" ></dxo-selection>
                                    <!-- <dxi-column [allowEditing]="false"
                                    dataField="clave"
                                    caption="Clave"
                                    alignment="left">
                                    </dxi-column> -->
                                    <dxi-column [allowEditing]="false"
                                        dataField="pregunta"
                                        caption="Pregunta">
                                    </dxi-column>
                                    <dxi-column [allowEditing]="false"
                                        dataField="nivel"
                                        caption="Nivel">
                                    </dxi-column>
                                    <dxi-column
                                    dataField="tipopregunta"
                                    caption="Tipopregunta"
                                    [visible]="false">
                                    </dxi-column>
                                    <dxi-column
                                      dataField="escalaevaluacion"
                                        caption="Escala evaluación"
                                        [visible]="false">
                                    </dxi-column>
                                    <dxi-column
                                    dataField="competencia"
                                    caption="competencia"
                                    [visible]="false">
                                    </dxi-column>
                                    <dxi-column
                                    dataField="criterio"
                                    caption="criterio"
                                    [visible]="false">
                                    </dxi-column>
                                    <dxi-column [allowEditing]="!ver" *ngIf="sistemaService.permisos.edicionespecial"
                                        alignment="center"
                                        dataField="obligatorio"
                                        caption="Obligatorio"
                                        dataType="boolean"
                                    >
                                    </dxi-column>
                                </dx-data-grid>
                            </div>
                        </div>
                    </div>
                </div>
                <div>

                </div>
                <div class="divisor20"></div>
                <div class="row margen">
                    <div class="col-12">
                        <div class="panelBotonesFiltro">
                            <button matTooltip="Cancelar" class="boton botonSM filledBlanco"
                            (click)="Salir()">
                            <span> {{'Cancelar'}}</span>
                        </button>
                        <div *ngIf="accion.accionid != 1">
                            <div class="divisorH16 "></div>
                            <button matTooltip="Guardar" class="boton botonSM filled"
                            (click)="Guardar()" [disabled]="ver"
                            *ngIf="sistemaService.permisos.agregar">
                            <span> {{'Guardar'}}</span>
                        </button>
                        </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    </div>
</div>
